import { FooterSite, HeaderSite } from '@acme/feature';
import Head from 'next/head';
import React from 'react';

const PrivacyPolicy = () => {
    return (
        <>
            <Head>
                <title>DapperGPT - Terms and Condition</title>
            </Head>
            <div className="flex flex-col min-h-screen bg-gradient-to-r from-blue-800 to-blue-500">
                {/* Header */}
                <HeaderSite />

                {/* Content */}
                <main className="container px-4 lg:px-20 pb-32 py-16 text-white flex-grow flex flex-col justify-start">
                    <h2 className="text-4xl font-bold mb-6">
                        Terms and Condition
                    </h2>

                    <div className=''>
                        <ol>
                            <li>
                                <p>Acceptance of Terms By using our SaaS application and associated services, you agree to be bound by these Terms and Conditions. If you do not agree with these Terms, you must not use our services.</p>
                            </li>
                            <li>
                                <p>Accounts and Registration To access certain features of our services, you may be required to register for an account. You agree to provide accurate and complete information when registering and to keep this information up-to-date.</p>
                            </li>
                            <li>
                                <p>Use of Services You agree to use our services for lawful purposes only and in compliance with all applicable laws and regulations. You may not use our services to engage in any activity that is harmful, harassing, defamatory, or otherwise objectionable.</p>
                            </li>
                            <li>
                                <p>Intellectual Property All content generated by our AI models, such as chat responses and notes, are the property of their respective copyright holders. You are responsible for ensuring that your use of our services complies with all applicable copyright laws and regulations.</p>
                            </li>
                            <li>
                                <p>Limitation of Liability We shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use our services.</p>
                            </li>
                            <li>
                                <p>All purchases are refundable within 5 days of purchase. If you are not satisfied with the product, please contact us.</p>
                                <p>Subscription and Payment By subscribing to our pro yearly or 6-month plan, you agree to pay the fees associated with that plan. We reserve the right to modify the pricing of our subscription plans at any time. Refunds will be granted at our sole discretion.</p>
                            </li>
                            <li>
                                <p>Termination We reserve the right to suspend or terminate your access to our services at any time, without notice, for any reason.</p>
                            </li>
                            <li>
                                <p>Changes to Terms of Service</p>
                                <p>We reserve the right to update or modify these Terms and Conditions at any time. Any changes will be posted on this page, and we encourage you to review our Terms and Conditions periodically. Your continued use of our services after any changes have been posted constitutes your acceptance of the revised Terms and Conditions.</p>
                            </li>
                            <li>
                                <p>Governing Law These Terms and Conditions shall be governed by and construed in accordance with the laws of Singapore.</p>
                            </li>
                            <li>
                                <p>Severability If any provision of these Terms and Conditions is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.</p>
                            </li>
                            <li>
                                <p>Entire Agreement These Terms and Conditions constitute the entire agreement between you and us concerning your use of our services and supersede any prior agreements or understandings.</p>
                            </li>
                            <li>
                                <p>Contact Us If you have any questions or concerns about these Terms and Conditions, please contact us at hi@dappergpt.com.</p>
                            </li>
                        </ol>
                    </div>
                </main>

                {/* Footer */}
                <FooterSite />
            </div>
        </>
    );
};

export default PrivacyPolicy;
